export const VIRTUAL_PROVIDER = "VIRTUAL" as const;

export const dropoffProviderType = [
  VIRTUAL_PROVIDER,
  // "BLUE_YONDER",
  // "HAPPY_RETURNS",
] as const;
export type DropoffProviderType = (typeof dropoffProviderType)[number];

const merchantFacingProviderNames: Record<DropoffProviderType, string> = {
  VIRTUAL: "Virtual",
};

export function getMerchantFacingProviderName(
  provider: DropoffProviderType,
): string {
  return merchantFacingProviderNames[provider];
}
